import React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import { ADMIN_LOGIN } from "./store/actions/auth";
import { SUCCESS } from "./store/actions";

import AppLayout from "./components/AppLayout/AppLayout";
import ProtectedRoute from "./components/Protected/ProtectedRoute";
import Dashboard from "./containers/Dashboard/Dashboard";
import Login from "./containers/Auth/Login/Login";
import Logout from "./containers/Auth/Logout/Logout";
import EventDashboard from "./containers/Events/EventDashboard/EventDashboard";

import AddMemberShip from "./containers/Membership/AddMembership/AddMembership";
import ViewMembership from "./containers/Membership/ViewMembership/ViewMembership";
import AddEvent from "./containers/Events/AddEvent/AddEvent";
import SelectMembership from "./containers/Membership/UpdateMembership/SelectMembership";
import SelectViewMembership from "./containers/Membership/ViewMembership/SelectMembership";
import UpdateMembershipForm from "./containers/Membership/UpdateMembership/UpdateMembershipForm";
import AddOrganisation from "./containers/Organisation/Forms/AddOrganisation/AddOrganisation";

import AddSpoc from "./containers/AddSpoc/AddSpoc";

import InvoiceDashboard from "./containers/Invoices/InvoiceDashboard/InvoiceDashboard";

import BookingsDashboard from "./containers/Bookings/BookingsDashboard";
import UsersBookings from "./containers/Bookings/UsersBookings";
import RoomwiseBookings from "./containers/Bookings/RoomwiseBookings";

import { CompletionState } from "./components/CompletionState/CompletionState";

import { store } from "./store/store";
import { request } from "./services/helpers";

import AddMembershipContext from "./Context/AddMembershipContext";
import UpdateMembershipContext from "./Context/UpdateMembershipContext";
import AddEventFormContext from "./Context/AddEventFormContext";

import AdhocInvoice from "./containers/Invoices/AdhocGen/AdhocInvoice";

// import AllActivityLogs from "./containers/ActivityLogs/AllActivityLogs";
import AdvMaterialTable from "./containers/ActivityLogs/AdvancedMatTable";

import jwtDecode from "jwt-decode";

const token = localStorage.getItem("token");
const fn = () => ({
  type: ADMIN_LOGIN[SUCCESS],
  payload: token,
});

console.log(process.env.NODE_ENV)

const checkAuth = () => {
  if (token) {
    const expiry = jwtDecode(token).expiry;
    const now = new Date();
    if (now.getTime() > expiry * 1000) {
      window.location.href = "/login";
      return;
    }
    request.defaults.headers.common["token"] = token;
    store.dispatch(fn()); // dispatch action to set user as authenticated
    return;
  }
};

checkAuth();

function App() {
  return (
    <Router>
      <Switch>
        <ProtectedRoute exact path="/">
          <AppLayout>
            <Dashboard />
          </AppLayout>
        </ProtectedRoute>

        <ProtectedRoute exact path="/add-membership">
          <AddMembershipContext>
            <AddMemberShip />
          </AddMembershipContext>
        </ProtectedRoute>

        <ProtectedRoute exact path="/add-spoc/:membershipId/:membershipName">
          <AddSpoc />
        </ProtectedRoute>

        <ProtectedRoute exact path="/update-membership">
          <SelectMembership />
        </ProtectedRoute>

        <ProtectedRoute exact path="/update-membership/:membershipId">
          <UpdateMembershipContext>
            <UpdateMembershipForm />
          </UpdateMembershipContext>
        </ProtectedRoute>

        <ProtectedRoute exact path="/view-membership">
          <SelectViewMembership />
        </ProtectedRoute>

        <ProtectedRoute exact path="/view-membership/:membershipId">
          <UpdateMembershipContext>
            <ViewMembership />
          </UpdateMembershipContext>
        </ProtectedRoute>

        <ProtectedRoute exact path="/events">
          <AppLayout>
            <EventDashboard />
          </AppLayout>
        </ProtectedRoute>

        <ProtectedRoute exact path="/add-event">
          <AddEventFormContext>
            <AddEvent />
          </AddEventFormContext>
        </ProtectedRoute>

        <ProtectedRoute exact path="/invoices">
          <AppLayout>
            <InvoiceDashboard />
          </AppLayout>
        </ProtectedRoute>

        <ProtectedRoute exact path='/bookings'>
          <AppLayout>
            <BookingsDashboard />
          </AppLayout>
        </ProtectedRoute>

        <ProtectedRoute exact path='/bookings/user-bookings'>
          <AppLayout>
            <UsersBookings />
          </AppLayout>
        </ProtectedRoute>

        <ProtectedRoute exact path='/bookings/room-wise-bookings'>
          <AppLayout>
            <RoomwiseBookings />
          </AppLayout>
        </ProtectedRoute>

        <ProtectedRoute exact path="/add-organisation">
          <AddOrganisation />
        </ProtectedRoute>

        {/* Use this route for showing completion states, open CompletionState for available props */}
        <ProtectedRoute exact path="/finish">
          <CompletionState />
        </ProtectedRoute>

        <ProtectedRoute exact path="/create-adhocInvoice">
          <AdhocInvoice />
        </ProtectedRoute>

        <ProtectedRoute exact path="/all-activityLogs">
          <AppLayout>
            <AdvMaterialTable />
            {/* <AllActivityLogs /> */}
          </AppLayout>
        </ProtectedRoute>

        {/* <ProtectedRoute exact path="/adv-materialTable">
          <AppLayout>
            <AdvMaterialTable />
          </AppLayout>
        </ProtectedRoute> */}

        <Route exact path="/login">
          <Login />
        </Route>

        <Route exact path="/logout">
          <Logout />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
